import { useMutation } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { renderPdf, type RenderPdfPayload } from "@/lib/pdf/renderPdf";

export type { RenderPdfPayload } from "@/lib/pdf/renderPdf";

/** Renders the unsigned PDF in the PDF Lambda (POST /render). Callers own the error toast. */
export const useRenderPdf = () => {
  return useMutation<Uint8Array, Error, RenderPdfPayload>({
    mutationFn: async (payload) => {
      const { data: sessionData } = await supabase.auth.getSession();
      const token = sessionData.session?.access_token;
      if (!token) throw new Error("unauthenticated");

      return renderPdf({ ...payload, token });
    },
  });
};
